export default "__VITE_ASSET__DFB5PZBW__"